import { zObj, zStr } from "./zodWrapper.js";
export const SubmitNotificationArgs = zObj({ message: zStr() });
//# sourceMappingURL=notifications.js.map